module.exports = __webpack_public_path__ + "static/media/icon.9dd59e87.png";